import React, { useContext } from "react";
import { observer } from "mobx-react";

import classNames from "classnames";
import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";

export default observer(function CashoutIndicator() {
	const { indicator } = useContext(MyBetsBetContext);

	if (indicator === 0) {
		return null;
	}

	const indicatorClasses = classNames("u-icon u-icon--xtny", {
		"u-icon--caret--up u-color--core--snow": indicator === 1,
		"u-icon--caret--down u-color--core--snow": indicator === -1,
	});

	return <i className={indicatorClasses} />;
});
